import {Component, Input, OnChanges, OnInit} from '@angular/core';
import {MapChart} from 'angular-highcharts';
import {Axis, PointOptionsObject, SeriesOptionsType} from 'highcharts';
import * as worldMap from '@highcharts/map-collection/custom/world.geo.json';
import {IntelligenceData} from '../../../models/intelligence-data.interface';
import {MessageService} from '../../../../shared/services/message.service';
import {Router} from '@angular/router';
import {AuthService} from '../../../../core/services/auth.service';
import HC_Exporting from 'highcharts/modules/exporting';
import * as Highcharts from 'highcharts/highmaps';
import HC_ExportData from 'highcharts/modules/export-data';

HC_Exporting(Highcharts);
HC_ExportData(Highcharts);

@Component({
  selector: 'app-systems-in-country-map-chart',
  templateUrl: './systems-in-country-map-chart.component.html',
  styleUrls: ['./systems-in-country-map-chart.component.scss']
})
export class SystemsInCountryMapChartComponent implements OnInit, OnChanges {

  textBelow!: string;
  chart!: MapChart;
  chartData!: SeriesOptionsType[];
  textBelowCode = 'intelligence.Country.SystemsInCountry.textBelow';
  isAdmin!: boolean;

  @Input()
  title!: string;
  @Input()
  subtitle!: string;
  @Input()
  data!: IntelligenceData[];

  constructor(private readonly messageService: MessageService,
              private readonly router: Router,
              private authService: AuthService) {
  }

  ngOnInit(): void {
    this.isAdmin = this.authService.getUserRoles().includes('WF_ADMIN');
    this.messageService.getDialogInfo(this.textBelowCode).subscribe((data) => {
      if (data !== null) {
        this.textBelow = data.description;
      }
    });
  }

  ngOnChanges(): void {
    if (this.data) {
      this.chartData = this.convertToChartData();
      this.chart = new MapChart({
        chart: {
          map: worldMap
        },
        title: {
          text: this.title
        },
        subtitle: {
          text: this.subtitle
        },
        exporting: {
          csv: {
            columnHeaderFormatter: (item: any, key: any) => {
              if (!item || item instanceof Axis) {
                return 'Country';
              } else {
                return item.name;
              }
            }
          },
          buttons: {
            contextButton: {
              menuItems: ['viewFullscreen', 'printChart', 'separator', 'downloadPNG', 'downloadJPEG', 'downloadPDF', 'downloadSVG',
                'downloadCSV', 'viewData'],
            }
          },
          menuItemDefinitions: {
            downloadCSV: {
              text: 'Download data'
            }
          }
        },
        colorAxis: {
          min: 0,
          minColor: '#c5e1ac',
          maxColor: '#416d1d'
        },
        mapNavigation: {
          enabled: true
        },
        tooltip: {
          formatter(): string[] | undefined {
            if (this.point.name) {
              const pointOptions = this.point as PointOptionsObject;
              if (pointOptions.custom?.absolute === 0) {
                return [this.point.name];
              }
              return ['<div class="center"><b>' + this.point.name + ' - ' + `${pointOptions.custom?.year}</b></div><br><br>`,
                `- Country response: ${pointOptions.custom?.answer} <br>` +
                `- Sum of PROs reported: ${pointOptions.custom?.totalAdditionResponses} <br>`
              ];
            }
            // If not null, use the default formatter
            // return tooltip.defaultFormatter.call(this, tooltip);
            return undefined;
          }
        },
        credits: {
          text: '© WEEE Forum Key Figures | Highcharts.com'
        },

        series: this.chartData
      });
    }
  }

  editTextBelow(): void {
    this.router.navigate(['/admin/chart-labels'], {state: {code: this.textBelowCode}}).then(
      () => {
        // do nothing
      }
    );
  }

  private convertToChartData(): SeriesOptionsType[] {

    const totalRespondents = this.data.length;
    this.chart?.ref?.hideData();
    const data = this.data.map(item => ({
      key: item.countryCode.toLowerCase(),
      value: +item.answer,
      custom: {
        year: item.year, answer: item.answer,
        totalResponses: item.totalResponses,
        totalRespondents,
        totalAdditionResponses: item.totalAdditionResponses
      }
    }));
    const chartData = [] as SeriesOptionsType[];
    chartData.push({
      name: 'Systems in country',
      joinBy: ['hc-key', 'key'],
      type: 'map',
      data
    });
    return chartData;
  }

}
